import script from "./communitySection.vue?vue&type=script&setup=true&lang=js"
export * from "./communitySection.vue?vue&type=script&setup=true&lang=js"

import "./communitySection.vue?vue&type=style&index=0&id=4416fe14&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4416fe14"]])

export default __exports__